import { Skeleton } from "@/app/components/shadcn/skeleton";

const CampaignCardSkeleton = () => (
  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 bg-white border border-gray-200 rounded-xl p-4 sm:p-5">
    <Skeleton className="w-14 h-14 rounded-lg shrink-0" />

    <div className="flex-1 min-w-0 space-y-2">
      <div className="flex items-center gap-2">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
      <Skeleton className="h-3 w-52" />
      <Skeleton className="h-5 w-28 rounded" />
    </div>

    <Skeleton className="h-8 w-36 rounded-lg shrink-0" />
  </div>
);

const CampaignsPageSkeleton = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
    {[1, 2, 3, 4, 5, 6].map((i) => (
      <CampaignCardSkeleton key={i} />
    ))}
  </div>
);

export default CampaignsPageSkeleton;